import {
  GET_USER_DEFINITIONS,
  GET_USER_DEFINITIONS_SUCCESS,
  ADD_NEW_USER_DEFINITION,
  ADD_USER_DEFINITION_SUCCESS,
  UPDATE_USER_DEFINITION,
  UPDATE_USER_DEFINITION_SUCCESS,
  DELETE_USER_DEFINITION,
  DELETE_USER_DEFINITION_SUCCESS,
  USER_DEFINITION_API_ERROR,
  CREATE_NEW_USER_DEFINITION,
  CREATE_NEW_USER_DEFINITION_SUCCESS,
  CONFIRM_NEW_USER_DEFINITION,
  CONFIRM_NEW_USER_DEFINITION_SUCCESS,
  INSERT_USER_KEYS,
  INSERT_USER_KEYS_SUCCESS,
  GET_USER_BY_USERNAME,
  GET_USER_BY_USERNAME_SUCCESS,
  GET_USERENCKEY_BY_MERCHANTGUID,
  GET_USERENCKEY_BY_MERCHANTGUID_SUCCESS,
  GET_APIKEY_BY_MERCHANTID,
  GET_APIKEY_BY_MERCHANTID_SUCCESS,
  GET_USER_ENCRYPTION_KEY_BY_MERCHANT_GUID,
  GET_USER_ENCRYPTION_KEY_BY_MERCHANT_GUID_SUCCESS,
  GET_USER_BY_USERNAME_SYNC,
  GET_USER_BY_USERNAME_SYNC_SUCCESS,
  GET_USER_DEFINITIONS_BY_USERNAME,
  GET_USER_DEFINITIONS_BY_USERNAME_SUCCESS,

} from "./actionTypes"

export const getUserDefinitions = () => ({
  type: GET_USER_DEFINITIONS,
})

export const getUserDefinitionsSuccess = userDefinition => ({
  type: GET_USER_DEFINITIONS_SUCCESS,
  payload: userDefinition,
})

export const getUserDefinitionsByUserName = userName => ({
  type: GET_USER_DEFINITIONS_BY_USERNAME,
  payload: userName,
})

export const getUserDefinitionsByUserNameSuccess = userName => ({
  type: GET_USER_DEFINITIONS_BY_USERNAME_SUCCESS,
  payload: userName,
})

export const addNewUserDefinition = userDefinition => ({
  type: ADD_NEW_USER_DEFINITION,
  payload: userDefinition,
})

export const addUserDefinitionSuccess = userDefinition => ({
  type: ADD_USER_DEFINITION_SUCCESS,
  payload: userDefinition,
})

export const updateUserDefinition = userDefinition => ({
  type: UPDATE_USER_DEFINITION,
  payload: userDefinition,
})

export const updateUserDefinitionSuccess = userDefinition => ({
  type: UPDATE_USER_DEFINITION_SUCCESS,
  payload: userDefinition,
})

export const deleteUserDefinition = guid => ({
  type: DELETE_USER_DEFINITION,
  payload: guid,
})

export const deleteUserDefinitionSuccess = guid => ({
  type: DELETE_USER_DEFINITION_SUCCESS,
  payload: guid,
})

export const addNewCreateUserAcount = user => ({
  type: CREATE_NEW_USER_DEFINITION,
  payload: user,
})

export const addNewCreateUserAcountSuccess = user => ({
  type: CREATE_NEW_USER_DEFINITION_SUCCESS,
  payload: user,
})

export const confirmUserAcount = userDefinition => ({
  type: CONFIRM_NEW_USER_DEFINITION,
  payload: userDefinition,
})

export const confirmUserAcountSuccess = userDefinition => ({
  type: CONFIRM_NEW_USER_DEFINITION_SUCCESS,
  payload: userDefinition,
})

export const insertUserKeys = (userName, encKey) => ({
  type: INSERT_USER_KEYS,
  payload: userName, encKey
})

export const insertUserKeysSuccess = (userName, encKey) => ({
  type: INSERT_USER_KEYS_SUCCESS,
  payload: userName, encKey
})

export const getUserByUserName = (userName) => ({
  type: GET_USER_BY_USERNAME,
  payload: userName
})

export const getUserByUserNameSuccess = (userName) => ({
  type: GET_USER_BY_USERNAME_SUCCESS,
  payload: userName
})

export const getUserByUserNameSync = (userName) => ({
  type: GET_USER_BY_USERNAME_SYNC,
  payload: userName
})

export const getUserByUserNameSyncSuccess = (userName) => ({
  type: GET_USER_BY_USERNAME_SYNC_SUCCESS,
  payload: userName
})

export const getUserEncKeyByMerchantGuid = (record) => ({
  type: GET_USERENCKEY_BY_MERCHANTGUID,
  payload: record
})

export const getUserEncKeyByMerchantGuidSuccess = (record) => ({
  type: GET_USERENCKEY_BY_MERCHANTGUID_SUCCESS,
  payload: record
})

export const getUserEncryptionKeyByMerchantGuid = (record) => ({
  type: GET_USER_ENCRYPTION_KEY_BY_MERCHANT_GUID,
  payload: record
})

export const getUserEncryptionKeyByMerchantGuidSuccess = (record) => ({
  type: GET_USER_ENCRYPTION_KEY_BY_MERCHANT_GUID_SUCCESS,
  payload: record
})

export const getApiKeyByMerchantId = (record) => ({
  type: GET_APIKEY_BY_MERCHANTID,
  payload: record
})

export const getApiKeyByMerchantIdSuccess = (record) => ({
  type: GET_APIKEY_BY_MERCHANTID_SUCCESS,
  payload: record
})

export const userDefinitionsApiError = error => ({
  type: USER_DEFINITION_API_ERROR,
  payload: error,
})

